<template>
  <div id="app" class="content">
    <router-view :key="$route.fullPath" /> 
  </div>
</template>
<script>
import fetchClient from './fetchClient';
import XuLy from './XuLy';
export default {
  name: "Appvue",
  components: {},
  mounted() {
  },
};
</script>
